import { render, staticRenderFns } from "./shareholderList.vue?vue&type=template&id=05f1289b&scoped=true"
import script from "./shareholderList.vue?vue&type=script&lang=js"
export * from "./shareholderList.vue?vue&type=script&lang=js"
import style0 from "./shareholderList.vue?vue&type=style&index=0&id=05f1289b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f1289b",
  null
  
)

export default component.exports